// removed by extract-text-webpack-plugin
module.exports = {"list":"general__list___1cjEF paddingLeft-m","item":"general__item___1-50B marginBottom-m marginLeft-m","lastItem":"general__lastItem___221kw"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-list/List/style/general.css
// module id = 184
// module chunks = 0 25